import serverConfig from '../server-config'
import { WebSocketService } from '@/controllers/websocketservice'

export class WebSocketController {
    private static instance: WebSocketController
    readonly webSocketService: WebSocketService

    private constructor() {
        this.webSocketService = new WebSocketService(serverConfig.chatURL)
        this.setupHandlers()
    }

    public static getInstance(): WebSocketController {
        if (!WebSocketController.instance) {
            WebSocketController.instance = new WebSocketController()
        }
        return WebSocketController.instance
    }

    public connect(): void {
        this.webSocketService.connect()
    }

    public disconnect(): void {
        this.webSocketService.disconnect()
    }

    public send(data: any): void {
        this.webSocketService.send(data)
    }

    public isConnected(): boolean {
        return this.webSocketService.isConnected()
    }

    private setupHandlers(): void {
        this.webSocketService.registerHandler('specificUpdateResponse', (data) => {
            // Handle specific updates
            console.log('Specific update received:', data)
        })

        this.webSocketService.registerHandler('messagesResponse', (data) => {
            // Handle messages
            console.log('Messages received:', data)
        })

        // Add more handlers as needed
    }
}
